import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";


export const IListOfInvestmentsMessagesScheme = z.object({
  your_investments_heading: themeScheme.MessageScheme.default("Twoje inwestycje"),
  add_investment: themeScheme.MessageScheme.default("Dodaj inwestycję"),
  all: themeScheme.MessageScheme.default("Wszystkie"),
  tender: themeScheme.MessageScheme.default("Przetarg / Ofertowanie"),
  in_progress: themeScheme.MessageScheme.default("Realizacja"),
  searchbar_placeholder: themeScheme.MessageScheme.default("Wyszukaj"),
});

export const IListOfInvestmentsSettingsScheme = z.object({
  background_image: z.string().optional(),
  background_image_mobile: z.string().optional(),
  add_investment_popup_id: themeScheme.RowPopupScheme.default(""),
});
